import { render, staticRenderFns } from "./locationSideView.vue?vue&type=template&id=10243405"
import script from "./locationSideView.vue?vue&type=script&lang=js"
export * from "./locationSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports